import type { SupportedLocale } from './types';

/**
 * Format currency with locale support
 */
export function formatCurrency(
  amount: number,
  locale: SupportedLocale = 'en',
  currency: string = 'EUR'
): string {
  const localeMap: Record<SupportedLocale, string> = {
    en: 'en-US',
    lv: 'lv-LV',
  };

  return new Intl.NumberFormat(localeMap[locale], {
    style: 'currency',
    currency,
  }).format(amount);
}

/**
 * Format number with locale-specific formatting
 */
export function formatNumber(
  value: number,
  locale: SupportedLocale = 'en',
  options?: Intl.NumberFormatOptions
): string {
  const localeMap: Record<SupportedLocale, string> = {
    en: 'en-US',
    lv: 'lv-LV',
  };

  return new Intl.NumberFormat(localeMap[locale], options).format(value);
}

/**
 * Formats fuel consumption (€/100km) as 1 decimal for given locale (defensive)
 */
export function formatFuelPer100(value: number, locale: SupportedLocale = 'en'): string {
  return formatNumber(value, locale, { minimumFractionDigits: 1, maximumFractionDigits: 1 });
}

/**
 * Formats a percentage value (0-100) with optional decimals
 */
export function formatPercent(value: number, locale: SupportedLocale = 'en', options: Intl.NumberFormatOptions = {}): string {
  return formatNumber(value, locale, { style: 'percent', minimumFractionDigits: options.minimumFractionDigits ?? 0, maximumFractionDigits: options.maximumFractionDigits ?? 0 });
}


